<script>
 import 'whatwg-fetch';
 import 'promise-polyfill/src/polyfill';
 export let center;
 export let companies;
 let container;
 let map;
 let markers = [];
 let zoom = 8;

 import { beforeUpdate, onMount } from 'svelte';

 async function generateMap(companies, center) {
   if ( ! map ) {
     map = new google.maps.Map(container, {
       zoom,
       center
     });
   }

   for (let i = 0; i < markers.length; i++) {
     markers[i].setMap(null);
   }
   markers = [];

   var infoWindow = new google.maps.InfoWindow();
   var bounds = new google.maps.LatLngBounds();
   var marker;

   for ( var i = 0; i < companies.length; i++ ) {
     for ( var j = 0; j < companies[i].facilities.length; j++ ) {
       marker = new google.maps.Marker({
         position: new google.maps.LatLng(
           parseFloat(companies[i].facilities[j].LAT),
           parseFloat(companies[i].facilities[j].LNG)
         ),
         map: map
       });

       markers.push(marker)

       google.maps.event.addListener(marker, 'click', (function(marker, i, j) {
         return function() {
           var content = '<p><strong>' + companies[i].name + '</strong><br>';
           content += companies[i].facilities[j].city + ", " + companies[i].facilities[j].state + "<br>";
           content += companies[i].facilities[j].phone1 + "</p>";

           infoWindow.setContent(content);
           infoWindow.open(map, marker);
         }
       })(marker, i, j));

       bounds.extend(marker.getPosition());
     }
   }

   map.fitBounds(bounds);
   if (companies.length === 1 && companies[0].facilities.length === 1) {
     map.setZoom(12);
   }
 }

 beforeUpdate(() => { generateMap(companies, center) });
 onMount(() => { generateMap(companies, center) });
</script>

<style>
 .map {
   min-height: 600px;
   max-height: 800px;
   width: 100%;
   margin-top: 20px;
 }
</style>

<div class="map" bind:this={container}></div>
